import { connect } from 'react-redux';
import ProgramListView from './program_list_view';
import {
  getCurrentUser,
  getStaffEPFilteredEventIds,
  getStaffEPFilteredProgramIds,
  getStaffEPFilteredServiceIds,
  getStaffEPFilteredEventsLoaded,
  getStaffEPFilteredServicesLoaded,
  getStaffEPFilteredProgramsLoaded,
  getResourceIdsSortedForStaff,
  getStaffEPABServiceIds,
  getStaffEPABServicesLoaded,
  getStaffEPAllProgramIds,
  getStaffEPAllEventIds,
  getStaffEPAllServiceIds,
  getStaffEPAllProgramsLoaded,
  getStaffEPAllEventsLoaded,
  getStaffEPAllServicesLoaded,
  getResourceIdsPaginatedForStaff,
  getMyOrgResourceIdsPaginatedForStaff,
  getMyOrgResourceIdsSortedForStaff,
  getMyDraftResourceIdsSortedForStaff,
  getMyDraftResourceIdsPaginatedForStaff,
} from '../../../reducer';

const mapStateToProps = (state, { preFilter, pageShown, setPageShown }) => {
  let eventsLoaded;
  let programsLoaded;
  let abServicesLoaded;
  let servicesLoaded;
  let resourceIdsSorted;
  let resourceIdsPaginated;
  let allPostingIds;

  if (preFilter) {
    const currentUser = getCurrentUser(state);
    const myOrgId = currentUser.getIn(['staffOrganization', 'id']);
    programsLoaded = getStaffEPAllProgramsLoaded(state);
    eventsLoaded = getStaffEPAllEventsLoaded(state);
    servicesLoaded = getStaffEPAllServicesLoaded(state);
    const programIds = getStaffEPAllProgramIds(state);
    const eventIds = getStaffEPAllEventIds(state);
    const serviceIds = getStaffEPAllServiceIds(state);

    switch (preFilter) {
      case 'draftsFilter':
        resourceIdsSorted = getMyDraftResourceIdsSortedForStaff(state);
        resourceIdsPaginated = getMyDraftResourceIdsPaginatedForStaff(state);
        break;
      default:
      case 'myOrgFilter':
        resourceIdsSorted = getMyOrgResourceIdsSortedForStaff(state, myOrgId);
        resourceIdsPaginated = getMyOrgResourceIdsPaginatedForStaff(state, myOrgId);
        break;
    }

    allPostingIds = programIds
      .map((id) => [id, { id, type: 'program' }])
      .union(eventIds.map((id) => [id, { id, type: 'event' }]))
      .union(serviceIds.map((id) => [id, { id, type: 'service' }]));
  } else {
    const eventIds = getStaffEPFilteredEventIds(state);
    const programIds = getStaffEPFilteredProgramIds(state);
    const abServiceIds = getStaffEPABServiceIds(state);
    const serviceIds = getStaffEPFilteredServiceIds(state);
    resourceIdsSorted = getResourceIdsSortedForStaff(state);
    resourceIdsPaginated = getResourceIdsPaginatedForStaff(state);
    eventsLoaded = getStaffEPFilteredEventsLoaded(state);
    programsLoaded = getStaffEPFilteredProgramsLoaded(state);
    abServicesLoaded = getStaffEPABServicesLoaded(state);
    servicesLoaded = getStaffEPFilteredServicesLoaded(state);
    allPostingIds = programIds
      .map((id) => [id, { id, type: 'program' }])
      .union(eventIds.map((id) => [id, { id, type: 'event' }]))
      .union(serviceIds.map((id) => [id, { id, type: 'service' }]))
      .union(abServiceIds.map((id) => [id, { id, type: 'service' }]));
  }

  const allPostingsMap = new Map(allPostingIds);
  const postingIds = resourceIdsPaginated.map((id) => allPostingsMap.get(id));

  return {
    preFilter,
    postingIds,
    programsLoaded,
    eventsLoaded,
    servicesLoaded,
    abServicesLoaded,
    pageShown,
    setPageShown,
    totalCount: resourceIdsSorted.size,
  };
};

const ProgramListContainer = connect(mapStateToProps)(ProgramListView);

export default ProgramListContainer;
